import React, { useState, useEffect, useCallback } from "react";
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "../common/common";
import moment from "moment";
import AsyncSelect from "react-select/async";
import Select from "react-select";
import Snackbar from "../snackbar";
import UploadButton from "./UploadButton";
import UploadStatus from "./UploadStatus";
import _ from "lodash";
import ImageCropper from "./ImageCropper";
import {useLocation, useNavigate} from 'react-router-dom';

import {
  TopToolbar,
  RefreshButton,
  ReferenceField,
  TextField,
  SelectInput,
  DateField,
  ListButton,
  ShowButton,
  Edit,
  DeleteButton,
  SimpleForm,
  TextInput,
  NumberInput,
  useResourceContext,
  useTranslate
} from "react-admin";

const ProductImagesEdit = ({ permissions, ...props }) => {
  const location = useLocation();
  const navigate = useNavigate();
  console.log("location",location)

  const EditActions = () => {
    const resource = useResourceContext();
    return (
    <TopToolbar>
      <RefreshButton />
      <ListButton basePath={resource} />
      {/* <DeleteButton basePath={basePath} record={data} resource={resource} /> */}
      {/* <ShowButton basePath={basePath} record={data} /> */}
    </TopToolbar>
    )
  };
  
  const translate = useTranslate();

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [onSaveDisabled, setOnSaveDisabled] = useState(false);

  const [formSettings, setFormSettings] = useState("");

  const [imageToCrop, setImageToCrop] = useState(undefined);
  const [croppedImage, setCroppedImage] = useState(undefined);
  const [bannerStatus, setBannerStatus] = useState(false);
  const [productName, setProductName] = useState("");
  const [productNameError, setProductNameError] = useState(true);
  const [productDescription, setProductDescription] = useState("");
  const [productDescriptionError, setProductDescriptionError] = useState(true);
  const [receivedImage, setReceivedImage] = useState("");
  const [imageFile, setImageFile] = useState("");
  const [fileDimension, setFileDimension] = useState({
    height: 0,
    width: 0,
  });
  const [fileError, setFileError] = useState(false);
  const [isImageSelected, setIsImageSelected] = useState(false);

  const [productImagesArray, setProductImagesArray] = useState(
    Array(3).fill(0)
  );

  const inputUpdatePhoto = React.useRef(null);
  const [fileExtError, setFileExtError] = useState(false);
  const [sizeError, setSizeError] = useState(false);

  const [receivedImagesArray, setReceivedImagesArray] = useState(["", "", ""]);

  /**
   * first product image variables
   */
  const [imageToCropP1, setImageToCropP1] = useState(undefined);
  const [croppedImageP1, setCroppedImageP1] = useState(undefined);
  const [imageFileP1, setImageFileP1] = useState("");
  const [fileDimensionP1, setFileDimensionP1] = useState({
    height: 0,
    width: 0,
  });
  const [fileErrorP1, setFileErrorP1] = useState(false);
  const [isImageSelectedP1, setIsImageSelectedP1] = useState(false);

  const inputUpdatePhotoP1 = React.useRef(null);
  const [fileExtErrorP1, setFileExtErrorP1] = useState(false);
  const [sizeErrorP1, setSizeErrorP1] = useState(false);

  /**
   * second product image variables
   */
  const [imageToCropP2, setImageToCropP2] = useState(undefined);
  const [croppedImageP2, setCroppedImageP2] = useState(undefined);
  const [imageFileP2, setImageFileP2] = useState("");
  const [fileDimensionP2, setFileDimensionP2] = useState({
    height: 0,
    width: 0,
  });
  const [fileErrorP2, setFileErrorP2] = useState(false);
  const [isImageSelectedP2, setIsImageSelectedP2] = useState(false);

  const inputUpdatePhotoP2 = React.useRef(null);
  const [fileExtErrorP2, setFileExtErrorP2] = useState(false);
  const [sizeErrorP2, setSizeErrorP2] = useState(false);

  /**
   * third product image variables
   */
  const [imageToCropP3, setImageToCropP3] = useState(undefined);
  const [croppedImageP3, setCroppedImageP3] = useState(undefined);
  const [imageFileP3, setImageFileP3] = useState("");
  const [fileDimensionP3, setFileDimensionP3] = useState({
    height: 0,
    width: 0,
  });
  const [fileErrorP3, setFileErrorP3] = useState(false);
  const [isImageSelectedP3, setIsImageSelectedP3] = useState(false);

  const inputUpdatePhotoP3 = React.useRef(null);
  const [fileExtErrorP3, setFileExtErrorP3] = useState(false);
  const [sizeErrorP3, setSizeErrorP3] = useState(false);

  React.useEffect(() => {
    const stateData = localStorage.getItem("__state");
    const userData = stateData ? JSON.parse(stateData) : false;

    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "GET";

    fetch(`${apiUrl}/${location?.pathname}`, {
      method: "GET",
      headers: {
        Authorization: userData._token,
        // "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        const responseData = json.data;
        console.log("responseData......",responseData);
        if (responseData.image_data) {
          setIsImageSelected(true);
        }
        if (
          responseData.product_images &&
          responseData.product_images &&
          responseData.product_images.length === 3
        ) {
          setIsImageSelectedP1(true);
          setIsImageSelectedP2(true);
          setIsImageSelectedP3(true);
        }
        if (responseData.name) {
          setProductNameError(false);
        }
        if (responseData.material_description) {
          setProductDescriptionError(false);
        }
        console.log("responseData ====>", responseData);
        setProductName(responseData.name);
        setProductDescription(responseData.material_description);
        setReceivedImage(responseData.image_data);
        console.log("image_data image_data", responseData.product_images);
        setBannerStatus(responseData.status);
        let imgDataFromRes = [...responseData.product_images];
        if (
          responseData.product_images &&
          responseData.product_images.length === 1
        ) {
          imgDataFromRes.splice(imgDataFromRes.length, 0, "", "");
          setReceivedImagesArray([...imgDataFromRes]);
          setProductImagesArray([...imgDataFromRes]);
        } else if (
          responseData.product_images &&
          responseData.product_images.length === 2
        ) {
          imgDataFromRes.splice(imgDataFromRes.length, 0, "");
          setReceivedImagesArray([...imgDataFromRes]);
          setProductImagesArray([...imgDataFromRes]);
        } else {
          setReceivedImagesArray([...responseData.product_images]);
          setProductImagesArray([...responseData.product_images]);
        }

        // let positionObject = positionOptions.find(
        //   (obj) => obj.value == responseData.position
        // );
      })
      .catch((error) => {
        console.log("error==>", error);
      });
  }, []);

  const sumbitForm = () => {
    // const splitBusinessId = business[0].id;
    setOnSaveDisabled(true);

    const stateData = localStorage.getItem("__state");
    const userData = stateData ? JSON.parse(stateData) : false;
    const imageArrayToPass =
      receivedImagesArray[0] !== "" &&
      receivedImagesArray[1] !== "" &&
      receivedImagesArray[2] !== ""
        ? receivedImagesArray
        : productImagesArray;

    const imageToSend = receivedImage == "" || receivedImage == null || receivedImage == undefined? imageFile :receivedImage

    const formData = new FormData();
    formData.append(
      "image_data",
      imageToSend
    );
    formData.append("name", productName.trim());
    formData.append("material_description", productDescription.trim());
    Array.from(imageArrayToPass).forEach((image, index) => {
      formData.append("product_images[" + index + "]", image);
    });
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    options.method = "PUT";

    for (var key of formData.entries()) {
      console.log(key[0] + ", " + key[1]);
    }
    options.body = formData;
    fetch(`${apiUrl}/${location?.pathname}`, {
      method: "PUT",
      body: formData,
      headers: {
        Authorization: userData._token,
        // "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((json) => {
        console.log(".............", json);
        setOnSaveDisabled(false);
        setShowSnackbar(true);
        setOnSaveDisabled(false);
        setTimeout(() => {
          navigate(-1);
        }, 1000);
      })
      .catch((error) => {
        console.log("error==>", error);
      });
  };

  async function dataUrlToFile(dataUrl, fileName) {
    var arr = dataUrl.split(",");
    var mime = arr[0].match(/:(.*?);/)[1];
    const res = await fetch(dataUrl);
    const blob = await res.blob();
    return new File([blob], fileName, { type: mime });
  }

  const onUploadFile = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const selectedFile = inputUpdatePhoto.current?.files;

      const fileExtension =
        selectedFile &&
        selectedFile[0].name.substring(
          selectedFile[0].name.lastIndexOf(".") + 1
        );
      const maxSize = 1;
      const validFileTypes = ["png", "jpg", "jpeg", "PNG", "JPG", "JPEG"];

      if (selectedFile[0].size / 1024 / 1024 > maxSize) {
        setFileExtError(false);
        setSizeError(true);
        setFileError(false);
      } else if (validFileTypes.indexOf(fileExtension) === -1) {
        setSizeError(false);
        setFileExtError(true);
        setFileError(false);
      } else {
        setFileExtError(false);
        setSizeError(false);

        const reader = new FileReader();
        var img = new Image();

        reader.onload = function (event) {
          // file is loaded

          img.onload = function () {
            console.log(img.width, img.height);
            setFileDimension({
              height: img.height,
              width: img.width,
            });
          };

          img.src = reader.result;
        };

        // console.log("image height abd stuffs", event.target.files);
        reader.addEventListener("load", (event) => {
          const image = reader.result;

          if (img.height == 345 && img.width == 345) {
            const fileData = dataUrlToFile(image, "croppedImage").then(
              function (file) {
                setImageFile(file);
              }
            );
            setIsImageSelected(true);
            setCroppedImage(image);
            setFileError(false);
            setImageToCrop(image);
          } else if (img.height < 345 || img.width < 345) {
            console.log("inin here");
            event.target.value = null;
            setFileError(true);
            setIsImageSelected(false);
            setCroppedImage(undefined);
            setImageToCrop(undefined);
          } else {
            setFileError(false);
            setCroppedImage(undefined);
            setImageToCrop(image);
          }
        });

        reader.readAsDataURL(event.target.files[0]);
      }
    }
  };

  const onUploadFileP1 = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const selectedFile = inputUpdatePhotoP1.current?.files;

      const fileExtension =
        selectedFile &&
        selectedFile[0].name.substring(
          selectedFile[0].name.lastIndexOf(".") + 1
        );
      const maxSize = 1;
      const validFileTypes = ["png", "jpg", "jpeg", "PNG", "JPG", "JPEG"];

      if (selectedFile[0].size / 1024 / 1024 > maxSize) {
        setFileExtErrorP1(false);
        setSizeErrorP1(true);
        setFileErrorP1(false);
      } else if (validFileTypes.indexOf(fileExtension) === -1) {
        setSizeErrorP1(false);
        setFileExtErrorP1(true);
        setFileErrorP1(false);
      } else {
        setFileExtErrorP1(false);
        setSizeErrorP1(false);

        const reader = new FileReader();
        var img = new Image();

        reader.onload = function (event) {
          // file is loaded

          img.onload = function () {
            console.log(img.width, img.height);
            setFileDimensionP1({
              height: img.height,
              width: img.width,
            });
          };

          img.src = reader.result;
        };

        // console.log("image height abd stuffs", event.target.files);
        reader.addEventListener("load", (event) => {
          const image = reader.result;

          if (img.height == 345 && img.width == 345) {
            const fileData = dataUrlToFile(image, "croppedImage").then(
              function (file) {
                setImageFileP1(file);
                const imageUpdateArr = [...productImagesArray];
                imageUpdateArr[0] = file;
                setProductImagesArray(imageUpdateArr);

                const recImageUpdateArr = [...receivedImagesArray];
                recImageUpdateArr[0] = "";
                setReceivedImagesArray(recImageUpdateArr);
              }
            );
            setIsImageSelectedP1(true);
            setCroppedImageP1(image);
            setFileErrorP1(false);
            setImageToCropP1(image);
          } else if (img.height < 345 || img.width < 345) {
            console.log("inin here");
            event.target.value = null;
            setFileErrorP1(true);
            setIsImageSelectedP1(false);
            setCroppedImageP1(undefined);
            setImageToCropP1(undefined);
          } else {
            setFileErrorP1(false);
            setCroppedImageP1(undefined);
            setImageToCropP1(image);
          }
        });

        reader.readAsDataURL(event.target.files[0]);
      }
    }
  };

  const onUploadFileP2 = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const selectedFile = inputUpdatePhotoP2.current?.files;

      const fileExtension =
        selectedFile &&
        selectedFile[0].name.substring(
          selectedFile[0].name.lastIndexOf(".") + 1
        );
      const maxSize = 1;
      const validFileTypes = ["png", "jpg", "jpeg", "PNG", "JPG", "JPEG"];

      if (selectedFile[0].size / 1024 / 1024 > maxSize) {
        setFileExtErrorP2(false);
        setSizeErrorP2(true);
        setFileErrorP2(false);
      } else if (validFileTypes.indexOf(fileExtension) === -1) {
        setSizeErrorP2(false);
        setFileExtErrorP2(true);
        setFileErrorP2(false);
      } else {
        setFileExtErrorP2(false);
        setSizeErrorP2(false);

        const reader = new FileReader();
        var img = new Image();

        reader.onload = function (event) {
          // file is loaded

          img.onload = function () {
            console.log(img.width, img.height);
            setFileDimensionP2({
              height: img.height,
              width: img.width,
            });
          };

          img.src = reader.result;
        };

        // console.log("image height abd stuffs", event.target.files);
        reader.addEventListener("load", (event) => {
          const image = reader.result;

          if (img.height == 345 && img.width == 345) {
            const fileData = dataUrlToFile(image, "croppedImage").then(
              function (file) {
                setImageFileP2(file);
                const imageUpdateArr = [...productImagesArray];
                imageUpdateArr[1] = file;
                setProductImagesArray(imageUpdateArr);

                const recImageUpdateArr = [...receivedImagesArray];
                recImageUpdateArr[1] = "";
                setReceivedImagesArray(recImageUpdateArr);
              }
            );
            setIsImageSelectedP2(true);
            setCroppedImageP2(image);
            setFileErrorP2(false);
            setImageToCropP2(image);
          } else if (img.height < 345 || img.width < 345) {
            console.log("inin here");
            event.target.value = null;
            setFileErrorP2(true);
            setIsImageSelectedP2(false);
            setCroppedImageP2(undefined);
            setImageToCropP2(undefined);
          } else {
            setFileErrorP2(false);
            setCroppedImageP2(undefined);
            setImageToCropP2(image);
          }
        });

        reader.readAsDataURL(event.target.files[0]);
      }
    }
  };

  const onUploadFileP3 = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const selectedFile = inputUpdatePhotoP3.current?.files;

      const fileExtension =
        selectedFile &&
        selectedFile[0].name.substring(
          selectedFile[0].name.lastIndexOf(".") + 1
        );
      const maxSize = 1;
      const validFileTypes = ["png", "jpg", "jpeg", "PNG", "JPG", "JPEG"];

      if (selectedFile[0].size / 1024 / 1024 > maxSize) {
        setFileExtErrorP3(false);
        setSizeErrorP3(true);
        setFileErrorP3(false);
      } else if (validFileTypes.indexOf(fileExtension) === -1) {
        setSizeErrorP3(false);
        setFileExtErrorP3(true);
        setFileErrorP3(false);
      } else {
        setFileExtErrorP3(false);
        setSizeErrorP3(false);

        const reader = new FileReader();
        var img = new Image();

        reader.onload = function (event) {
          // file is loaded

          img.onload = function () {
            console.log(img.width, img.height);
            setFileDimensionP3({
              height: img.height,
              width: img.width,
            });
          };

          img.src = reader.result;
        };

        // console.log("image height abd stuffs", event.target.files);
        reader.addEventListener("load", (event) => {
          const image = reader.result;

          if (img.height == 345 && img.width == 345) {
            const fileData = dataUrlToFile(image, "croppedImage").then(
              function (file) {
                setImageFileP3(file);
                const imageUpdateArr = [...productImagesArray];
                imageUpdateArr[2] = file;
                setProductImagesArray(imageUpdateArr);

                const recImageUpdateArr = [...receivedImagesArray];
                recImageUpdateArr[2] = "";
                setReceivedImagesArray(recImageUpdateArr);
              }
            );
            setIsImageSelectedP3(true);
            setCroppedImageP3(image);
            setFileErrorP3(false);
            setImageToCropP3(image);
          } else if (img.height < 345 || img.width < 345) {
            console.log("inin here");
            event.target.value = null;
            setFileErrorP3(true);
            setIsImageSelectedP3(false);
            setCroppedImageP3(undefined);
            setImageToCropP3(undefined);
          } else {
            setFileErrorP3(false);
            setCroppedImageP3(undefined);
            setImageToCropP3(image);
          }
        });

        reader.readAsDataURL(event.target.files[0]);
      }
    }
  };

  const changeProductName = (event) => {
    let positionObject = event.target.value;
    if (
      event.target.value === "" ||
      event.target.value === undefined ||
      event.target.value === null ||
      !event.target.value.trim().length
    ) {
      setProductNameError(true);
    } else {
      setProductNameError(false);
    }
    setProductName(positionObject);
  };

  const changeProductDescription = (event) => {
    let positionObject = event.target.value;
    if (
      event.target.value === "" ||
      event.target.value === undefined ||
      event.target.value === null ||
      !event.target.value.trim().length
    ) {
      setProductDescriptionError(true);
    } else {
      setProductDescriptionError(false);
    }
    setProductDescription(positionObject);
  };

  useEffect(() => {
    const formSetting = JSON.parse(localStorage.getItem("__state"));
    setFormSettings(formSetting.proof_of_payment_form);
  }, []);

  // console.log('business id offfffffff', businessId);

  return formSettings ? (
    <Edit actions={<EditActions />} {...props} 
    title={translate('resources.productsmaster.fields.product_images_edit')}>
      {/* <SimpleForm redirect="list"> */}
      <div className={`proof-of-payment-form-page`}>
        <div className="pop-order-number-input">
          <span>
          {translate('resources.productsmaster.fields.product_name')}
<sup>*</sup>
          </span>
          <input
            type="text"
            placeholder=""
            className="product-name-input"
            value={productName}
            onChange={changeProductName}
          />
        </div>

        <div className="pop-order-number-input">
          <span>
          {translate('resources.productsmaster.fields.product_desc')}<sup>*</sup>
          </span>
          <textarea
            className="product-description-input"
            name="description"
            maxLength="340"
            value={productDescription}
            onChange={changeProductDescription}
          />
        </div>

        <div className="pop-order-number-input">
          <span className="upload-images-heading">{translate('resources.productsmaster.fields.upload_images')}</span>
          <div className="valid-file-upload">
            <p>{translate('resources.productsmaster.fields.instruction')}</p>
            <ul>
              <li>
              {translate('resources.productsmaster.fields.allowed_type')}
              </li>
              <li> {translate('resources.productsmaster.fields.max_size')}</li>
              <li>
              {translate('resources.productsmaster.fields.pixel')}
              </li>
              <li>
              {translate('resources.productsmaster.fields.product_content')}
              </li>
            </ul>
          </div>
          <p className="image-representation">{translate('resources.productsmaster.fields.image_repr')}</p>
          <div className="parent-bg">
            <div className="hparent-line-pixel">
              <p className="hparent-line" />
              <p className="hpixel-text">345px</p>
              <p className="hparent-line" />
            </div>
            <div className="vparent-line-pixel">
              <p className="vparent-line" />
              <p className="vpixel-text">345px</p>
              <p className="vparent-line" />
            </div>
            <div className="child-bg">
              <div className="hchild-line-pixel">
                <p className="hchild-line" />
                <p className="hpixel-text">245px</p>
                <p className="hchild-line" />
              </div>
              <div className="vchild-line-pixel">
                <p className="vchild-line" />
                <p className="vpixel-text">245px</p>
                <p className="vchild-line" />
              </div>
            </div>
          </div>
        </div>

        {receivedImage != "" &&
        typeof receivedImage !== "undefined" &&
        receivedImage !== null ? (
          <div className="pop-order-number-input">
            <span>
            {translate('resources.productsmaster.fields.list_image')}<sup>*</sup>
            </span>
            <div className="product-uploaded-img">
              <img className="product-img" src={receivedImage} />
              <button
                onClick={() => {
                  setReceivedImage("");
                  setIsImageSelected(false);
                }}
              >
                X
              </button>
            </div>
          </div>
        ) : (
          <div className="pop-order-number-input">
            <span>
            {translate('resources.productsmaster.fields.list_image')}<sup>*</sup>
            </span>
            <input
              type="file"
              onChange={onUploadFile}
              accept=".png, .jpg, .jpeg"
              ref={inputUpdatePhoto}
            />
            {fileError && (
              <div className="valid-file-upload-error">
                <p>
                {translate('resources.productsmaster.fields.image_dim')}
                </p>
              </div>
            )}
            {sizeError && (
              <div className="valid-file-upload-error">
                <p>{translate('resources.productsmaster.fields.img_size')}</p>
              </div>
            )}
            {fileExtError && (
              <div className="valid-file-upload-error">
                <p>{translate('resources.productsmaster.fields.select_image')}</p>
              </div>
            )}
            {(fileDimension.width > 345 || fileDimension.height > 345) && (
              <div>
                <ImageCropper
                  imageToCrop={imageToCrop}
                  onImageCropped={(croppedImage) => {
                    setCroppedImage(croppedImage[0]);
                    const newImage = new File(
                      [croppedImage[1]],
                      croppedImage[1].name,
                      { type: croppedImage[1].type }
                    );
                    setImageFile(newImage);
                    setIsImageSelected(true);
                    console.log("---------------", newImage);

                    //convert to base64
                    // var reader = new FileReader();
                    // let imageFile = "";
                    // reader.readAsDataURL(croppedImage[1]);
                    // reader.onloadend = function () {
                    //   setImageFile(reader.result);
                    //   console.log("Base64 String - ", imageFile);
                    // };
                  }}
                />
              </div>
            )}
            {(croppedImage ||
              (fileDimension.width == 345 && fileDimension.height == 345)) && (
              <div>
                <p className="cropped-image-heading">{translate('resources.productsmaster.fields.cropped_img')}</p>
                <img alt="Cropped Img" src={croppedImage} />
              </div>
            )}
          </div>
        )}

        {receivedImagesArray[0] != "" &&
        typeof receivedImagesArray[0] !== "undefined" ? (
          <div className="pop-order-number-input">
            <span>
            {translate('resources.productsmaster.fields.front_image')}
            {/* <sup>*</sup> */}
            </span>
            <div className="product-uploaded-img">
              <img className="product-img" src={receivedImagesArray[0]} />
              <button
                onClick={() => {
                  const imageUpdateArr = [...receivedImagesArray];
                  console.log("updated bef image ", imageUpdateArr);
                  imageUpdateArr[0] = "";
                  console.log("updated  image ", imageUpdateArr);
                  setReceivedImagesArray(imageUpdateArr);
                  setIsImageSelectedP1(false);
                }}
              >
                X
              </button>
            </div>
          </div>
        ) : (
          <div className="pop-order-number-input">
            <span>
            {translate('resources.productsmaster.fields.front_image')}
            {/* <sup>*</sup> */}
            </span>
            <input
              type="file"
              onChange={onUploadFileP1}
              accept=".png, .jpg, .jpeg"
              ref={inputUpdatePhotoP1}
            />
            {fileErrorP1 && (
              <div className="valid-file-upload-error">
                <p>
                {translate('resources.productsmaster.fields.image_dim')}
                </p>
              </div>
            )}
            {sizeErrorP1 && (
              <div className="valid-file-upload-error">
                <p> {translate('resources.productsmaster.fields.img_size')}</p>
              </div>
            )}
            {fileExtErrorP1 && (
              <div className="valid-file-upload-error">
                <p>{translate('resources.productsmaster.fields.select_image')}</p>
              </div>
            )}
            {(fileDimensionP1.width > 345 || fileDimensionP1.height > 345) && (
              <div>
                <ImageCropper
                  imageToCrop={imageToCropP1}
                  onImageCropped={(croppedImage) => {
                    setCroppedImageP1(croppedImage[0]);
                    const newImage = new File(
                      [croppedImage[1]],
                      croppedImage[1].name,
                      { type: croppedImage[1].type }
                    );
                    setImageFileP1(newImage);
                    const imageUpdateArr = [...productImagesArray];
                    imageUpdateArr[0] = newImage;
                    setProductImagesArray(imageUpdateArr);
                    setIsImageSelectedP1(true);

                    const recImageUpdateArr = [...receivedImagesArray];
                    recImageUpdateArr[0] = "";
                    setReceivedImagesArray(recImageUpdateArr);
                    console.log("---------------", newImage);
                  }}
                />
              </div>
            )}
            {(croppedImageP1 ||
              (fileDimensionP1.width == 345 &&
                fileDimensionP1.height == 345)) && (
              <div>
                <p className="cropped-image-heading">{translate('resources.productsmaster.fields.cropped_img')}</p>
                <img alt="Cropped Img" src={croppedImageP1} />
              </div>
            )}
          </div>
        )}

        {receivedImagesArray[1] != "" &&
        typeof receivedImagesArray[1] !== "undefined" ? (
          <div className="pop-order-number-input">
            <span>
            {translate('resources.productsmaster.fields.back_image')}
            {/* <sup>*</sup> */}
            </span>
            <div className="product-uploaded-img">
              <img className="product-img" src={receivedImagesArray[1]} />
              <button
                onClick={() => {
                  const imageUpdateArr = [...receivedImagesArray];
                  imageUpdateArr[1] = "";
                  setReceivedImagesArray(imageUpdateArr);
                  setIsImageSelectedP2(false);
                }}
              >
                X
              </button>
            </div>
          </div>
        ) : (
          <div className="pop-order-number-input">
            <span>
            {translate('resources.productsmaster.fields.back_image')}
            {/* <sup>*</sup> */}
            </span>
            <input
              type="file"
              onChange={onUploadFileP2}
              accept=".png, .jpg, .jpeg"
              ref={inputUpdatePhotoP2}
            />
            {fileErrorP2 && (
              <div className="valid-file-upload-error">
                <p>
                {translate('resources.productsmaster.fields.image_dim')}
                </p>
              </div>
            )}
            {sizeErrorP2 && (
              <div className="valid-file-upload-error">
                <p>{translate('resources.productsmaster.fields.img_size')}</p>
              </div>
            )}
            {fileExtErrorP2 && (
              <div className="valid-file-upload-error">
                <p>{translate('resources.productsmaster.fields.select_image')}</p>
              </div>
            )}
            {(fileDimensionP2.width > 345 || fileDimensionP2.height > 345) && (
              <div>
                <ImageCropper
                  imageToCrop={imageToCropP2}
                  onImageCropped={(croppedImage) => {
                    setCroppedImageP2(croppedImage[0]);
                    const newImage = new File(
                      [croppedImage[1]],
                      croppedImage[1].name,
                      { type: croppedImage[1].type }
                    );
                    setImageFileP2(newImage);
                    const imageUpdateArr = [...productImagesArray];
                    imageUpdateArr[1] = newImage;
                    setProductImagesArray(imageUpdateArr);
                    setIsImageSelectedP2(true);

                    const recImageUpdateArr = [...receivedImagesArray];
                    recImageUpdateArr[1] = "";
                    setReceivedImagesArray(recImageUpdateArr);
                    console.log("---------------", newImage);
                  }}
                />
              </div>
            )}
            {(croppedImageP2 ||
              (fileDimensionP2.width == 345 &&
                fileDimensionP2.height == 345)) && (
              <div>
                <p className="cropped-image-heading">{translate('resources.productsmaster.fields.cropped_img')}</p>
                <img alt="Cropped Img" src={croppedImageP2} />
              </div>
            )}
          </div>
        )}

        {receivedImagesArray[2] != "" &&
        typeof receivedImagesArray[2] !== "undefined" ? (
          <div className="pop-order-number-input">
            <span>
            {translate('resources.productsmaster.fields.side_image')}
            {/* <sup>*</sup> */}
            </span>
            <div className="product-uploaded-img">
              <img className="product-img" src={receivedImagesArray[2]} />
              <button
                onClick={() => {
                  const imageUpdateArr = [...receivedImagesArray];
                  imageUpdateArr[2] = "";
                  setReceivedImagesArray(imageUpdateArr);
                  setIsImageSelectedP3(false);
                }}
              >
                X
              </button>
            </div>
          </div>
        ) : (
          <div className="pop-order-number-input">
            <span>
            {translate('resources.productsmaster.fields.side_image')}
            {/* <sup>*</sup> */}
            </span>
            <input
              type="file"
              onChange={onUploadFileP3}
              accept=".png, .jpg, .jpeg"
              ref={inputUpdatePhotoP3}
            />
            {fileErrorP3 && (
              <div className="valid-file-upload-error">
                <p>
                {translate('resources.productsmaster.fields.image_dim')}
                </p>
              </div>
            )}
            {sizeErrorP3 && (
              <div className="valid-file-upload-error">
                <p>{translate('resources.productsmaster.fields.img_size')}</p>
              </div>
            )}
            {fileExtErrorP3 && (
              <div className="valid-file-upload-error">
                <p>{translate('resources.productsmaster.fields.select_image')}</p>
              </div>
            )}
            {(fileDimensionP3.width > 345 || fileDimensionP3.height > 345) && (
              <div>
                <ImageCropper
                  imageToCrop={imageToCropP3}
                  onImageCropped={(croppedImage) => {
                    setCroppedImageP3(croppedImage[0]);
                    const newImage = new File(
                      [croppedImage[1]],
                      croppedImage[1].name,
                      { type: croppedImage[1].type }
                    );
                    setImageFileP3(newImage);
                    const imageUpdateArr = [...productImagesArray];
                    imageUpdateArr[2] = newImage;
                    setProductImagesArray(imageUpdateArr);
                    setIsImageSelectedP3(true);

                    const recImageUpdateArr = [...receivedImagesArray];
                    recImageUpdateArr[2] = "";
                    setReceivedImagesArray(recImageUpdateArr);
                    console.log("---------------", newImage);
                  }}
                />
              </div>
            )}
            {(croppedImageP3 ||
              (fileDimensionP3.width == 345 &&
                fileDimensionP3.height == 345)) && (
              <div>
                <p className="cropped-image-heading">{translate('resources.productsmaster.fields.cropped_img')}</p>
                <img alt="Cropped Img" src={croppedImageP3} />
              </div>
            )}
          </div>
        )}
        {console.log('hgfjyghsdafsghajfsad',!isImageSelected,
              !isImageSelectedP1 ,
              !isImageSelectedP2 ,
              !isImageSelectedP3 ,
              productNameError ,
              productDescriptionError ,
              onSaveDisabled)}

        <div className="so-save-button">
          <button
            onClick={sumbitForm}
            disabled={
              !isImageSelected ||
              (imageToCropP1 != undefined && !isImageSelectedP1 )||
              (imageToCropP2 != undefined && !isImageSelectedP2) ||
              (imageToCropP3 != undefined && !isImageSelectedP3) ||
              productNameError ||
              productDescriptionError ||
              onSaveDisabled
            }
          >
            <span>{translate('resources.productsmaster.fields.save')}</span>
          </button>
        </div>
        {showSnackbar && <Snackbar message="Element Created" />}
      </div>
      {/* </SimpleForm> */}
    </Edit>
  ) : (
    <div>{translate('resources.productsmaster.fields.loading')}</div>
  );
};

export default ProductImagesEdit;
